import { formatRecordData } from '../utils/utilities'
import MemoryStore from '../utils/memory-store'
import ConnectorsFormContainer from '../connectors/containers/connectors-form-container'
import Enums from '../utils/enums'

export const filterViewData = (viewData, searchFilter) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return viewData
  } else {
    return viewData.filter(
      t =>
        t.data.name.toLowerCase().indexOf(searchFilter) > -1 ||
        t.data.key.toLowerCase().indexOf(searchFilter) > -1 ||
        t.data.description.toLowerCase().indexOf(searchFilter) > -1
    )
  }
}

export const filterRouteData = (data, searchFilter, callback) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return callback(data)
  } else {
    return callback(
      data.filter(
        t =>
          t.name.toLowerCase().indexOf(searchFilter) > -1 ||
          t.description.toLowerCase().indexOf(searchFilter) > -1 ||
          t.key.toLowerCase().indexOf(searchFilter) > -1
      )
    )
  }
}

export const formatRecord = (entry, data) => {
  let tempIndex = 0

  entry.key = entry._id // Needed for View's Unique key requirement
  entry = formatRecordData(entry)
  entry.data.connectionType = entry.data.connectionType.trim()
  entry.data.isActiveDescription = entry.data.isActive ? 'Yes' : 'No' // Needed for View Column

  if (entry.custom.isNewDoc) {
    // Add new Entry to State
    entry.custom.isNewDoc = false
    entry.custom.action = 'create'
    entry.custom.credentialsReset = true
    data.push(entry)
  } else {
    if (entry.custom.isSavedDoc) {
      entry.custom.action = 'update'
    } else {
      entry.custom.action = 'create'
    }

    // Update Entry in State
    tempIndex = data.findIndex(t => t._id === entry._id)
    data[tempIndex] = entry
  }

  return data
}

export const createCopy = (currEntryData, callback) => {
  const newEntry = JSON.parse(JSON.stringify(MemoryStore.connectors.dataTemplate))
  newEntry._id = new Date().getTime().toString()
  newEntry.custom.tempId = newEntry._id

  const entryData = JSON.parse(JSON.stringify(currEntryData))
  const tabType = Enums.VALUES_STRINGS.FORM
  const content = ConnectorsFormContainer
  const closable = true
  const key = newEntry._id
  const app = Enums.APP_IDS.CONNECTORS

  let title = Enums.APP_PROFILE_TITLES.connectors + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE
  let payload = {}

  // create unique key
  entryData.key = currEntryData.key + '_copy'
  entryData.name = currEntryData.name + ' (Copy)'

  newEntry.data = entryData

  title += entryData.key

  payload = {
    content,
    title,
    key,
    app,
    tabType,
    closable
  }

  MemoryStore.activeEntries[newEntry._id] = newEntry

  callback(payload)
}

export const resetConnectionPool = profileKey => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        await MemoryStore.agilite.Connectors.resetConnectionPool(profileKey)
        resolve()
      } catch (error) {
        if (error.response?.data.errorMessage) {
          reject(error.response.data.errorMessage)
        } else if (error.message) {
          reject(error.message)
        } else {
          reject(Enums.MESSAGES.UNKNOWN_ERROR)
        }
      }
    })()
  })
}
